import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss',
})
export class PaginationComponent implements OnChanges {
  @Input() currentPage = 1;
  @Input() totalPages = 1;
  @Input() pageSize = 10;

  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  pages: number[] = [];
  pageSizeOptions = [10, 20, 30, 50];

  inputPage = this.currentPage;

  ngOnChanges(): void {
    this.pages = Array.from({ length: this.totalPages }, (_, i) => i + 1);
    this.inputPage = this.currentPage;
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
      this.pageChange.emit(page);
    }
  }

  onInputPageChange(value: string): void {
    const page = parseInt(value, 10);
    if (!isNaN(page) && page >= 1 && page <= this.totalPages) {
      this.inputPage = page;
      this.goToPage(page);
    }
  }

  onPageSizeChange(value: string): void {
    this.pageSizeChange.emit(+value);
  }
}
